import { Button } from "@/components/ui/button";
import { ChevronDown, Plus } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { ClassListItem } from "./ClassListItem";

interface GymListProps {
  linkedGyms: any[];
  filteredClasses: any[];
  openGyms: Record<string, boolean>;
  onToggleGym: (gymId: string) => void;
  onAddClass: (gymId: string) => void;
  onEditClass: (class_: any) => void;
  onDeleteClass: (id: string) => void;
  onSelectClass: (id: string) => void;
  userRole?: string;
}

export const GymList = ({
  linkedGyms,
  filteredClasses,
  openGyms,
  onToggleGym,
  onAddClass,
  onEditClass,
  onDeleteClass,
  onSelectClass,
  userRole,
}: GymListProps) => {
  if (!linkedGyms || linkedGyms.length === 0) {
    return (
      <div className="text-center text-muted-foreground">
        No hay gimnasios vinculados
      </div>
    );
  }

  // Para managers, mostrar vista simple sin desplegables
  if (userRole === 'manager') {
    const gym = linkedGyms[0]; // Los managers solo ven un gimnasio
    return (
      <div className="space-y-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">{gym.name}</h3>
          <Button onClick={() => onAddClass(gym.id)} size="sm">
            <Plus className="h-4 w-4 mr-2" />
            Agregar Clase
          </Button>
        </div>

        <div className="space-y-4">
          {filteredClasses
            ?.filter((class_) => class_.gym_id === gym.id)
            .map((class_) => (
              <ClassListItem
                key={class_.id}
                class_={class_}
                onEdit={onEditClass}
                onDelete={onDeleteClass}
                onClick={() => onSelectClass(class_.id)}
              />
            ))}
        </div>
      </div>
    );
  }

  // Para profesores, mantener la vista con desplegables
  return (
    <>
      {linkedGyms.map((gym: any) => (
        <Collapsible
          key={gym.id}
          open={openGyms[gym.id]}
          onOpenChange={() => onToggleGym(gym.id)}
          className="border rounded-lg p-4"
        >
          <div className="flex justify-between items-center">
            <CollapsibleTrigger className="flex items-center gap-2 hover:text-primary transition-colors">
              <ChevronDown
                className={cn(
                  "h-4 w-4 transition-transform duration-200",
                  openGyms[gym.id] ? "transform rotate-180" : ""
                )}
              />
              <h3 className="text-lg font-medium">{gym.name}</h3>
            </CollapsibleTrigger>
            <Button onClick={() => onAddClass(gym.id)} size="sm">
              <Plus className="h-4 w-4 mr-2" />
              Agregar Clase
            </Button>
          </div>

          <CollapsibleContent className="space-y-4 mt-4">
            {filteredClasses
              ?.filter((class_) => class_.gym_id === gym.id)
              .map((class_) => (
                <ClassListItem
                  key={class_.id}
                  class_={class_}
                  onEdit={onEditClass}
                  onDelete={onDeleteClass}
                  onClick={() => onSelectClass(class_.id)}
                />
              ))}
          </CollapsibleContent>
        </Collapsible>
      ))}
    </>
  );
};